import { defineCustomElement } from '@tyler-components-web/core';
import { BottomSheetComponent } from './bottom-sheet';
export * from './bottom-sheet-adapter';
export * from './bottom-sheet-constants';
export * from './bottom-sheet-foundation';
export * from './bottom-sheet';
export function defineBottomSheetComponent() {
    defineCustomElement(BottomSheetComponent);
}
